import classNames from 'classnames';
import React, {useMemo} from 'react';
import {EditableComponentProps, useEditableComponent} from './editableComponent';

const emailReg = /(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/g;

export default function EditablePar(props: EditableComponentProps) {
    const {textKey, className} = props;
    const [content, onChange, editable] = useEditableComponent(textKey);
    const parsedContent = useMemo(() => {
        let emailMatches = emailReg.exec(content);
        let parsed = content;
        while (emailMatches) {
            for (const match of emailMatches) {
                if (!match?.includes('@') || match?.includes('href=')) continue;
                const replacement = `<a href='mailto:${match}' class='default-link' target='_blank'>${match}</a>`;
                parsed = parsed.replace(match, replacement);
            }
            emailMatches = emailReg.exec(content);
        }
        return parsed;
    }, [content]);

    return (
        <p contentEditable={editable} className={classNames('editable-component', 'editable-par', className)}
           onInput={onChange} dangerouslySetInnerHTML={{__html: parsedContent}}/>
    );
}

EditablePar.displayName = 'EditablePar';